/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Annual
 * 
 * 1 = Sickness
 * 
 * 2 = Appointment
 * 
 * 3 = CarryOver
 * 
 * 4 = Compassionate
 * 
 * 5 = EmployeeOfMonth
 * 
 * 6 = JuryService
 * 
 * 7 = Training
 * 
 * 8 = Unpaid
 * 
 * 9 = Other
 */
export enum LeaveType {
  Annual = 0,
  Sickness = 1,
  Appointment = 2,
  CarryOver = 3,
  Compassionate = 4,
  EmployeeOfMonth = 5,
  JuryService = 6,
  Training = 7,
  Unpaid = 8,
  Other = 9
}
